import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import GeoAnalyticsTable from "./partials/geo-analytics-table.jsx";

const BEGINNING_OF_GEOANALYTICS_DATE = new Date(2017, 7, 24); // Aug 24, 2017

class GeoAnalytics extends React.Component {
  static getStores() {
    return [EventBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getGeoAnalytics: AnalyticsStore.getGeoAnalytics
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      AnalyticsActions.fetchGeoAnalytics.defer(newProps.params.eventBucketId);
      EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
    }
  }

  render() {
    const { eventBucketId } = this.props.params,
      eventBucket = this.props.getEventBucketById(eventBucketId),
      geoAnalytics = this.props.getGeoAnalytics(eventBucketId);

    if (!geoAnalytics || !eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="geo analytics"
          subpath="geo"
        />

        {new Date(eventBucket.created_at) < BEGINNING_OF_GEOANALYTICS_DATE ? (
          <p style={{ fontStyle: "italic" }}>
            Note: Geo analytics data only includes orders placed after August
            23, 2017.
          </p>
        ) : null}

        <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
          Web orders by postal code
        </h2>
        <GeoAnalyticsTable
          eventBucket={eventBucket}
          data={geoAnalytics.by_postal_code}
        />
      </div>
    );
  }
}

export default connectToStores(GeoAnalytics);



// WEBPACK FOOTER //
// ./src/app/components/geo-analytics.jsx